// This file is auto-generated by bin/rails stones:update_similar_mappings

const similarStones = (stone_code) => {
  try {
    if (!stone_code) return '';
    let stone_code_array = []
    switch (stone_code.toString().toUpperCase()) {
      case 'G1':
      case '01GARN':
      case 'RHODOLITE':
        stone_code_array = ["RHODOLITE", "SWKRed", "01", "S01GARN", "G1", "01GARN", "F01GARN", "RoseQtz"];
        break;
      case '01':
      case 'S01GARN':
      case 'JANUARY':
      case 'GARNET':
      case 'F01GARN':
        stone_code_array = ["SWKRed", "G1", "01GARN", "01", "S01GARN", "F01GARN", "RoseQtz"];
        break;
      case 'G2':
      case '02AMTH':
        stone_code_array = ["SWKAmethyst", "02", "S02AMTH", "G2", "02AMTH", "F02AMTH"];
        break;
      case '02':
      case 'S02AMTH':
      case 'FEBRUARY':
      case 'AMETHYST':
      case 'F02AMTH':
        stone_code_array = ["SWKAmethyst", "G2", "02AMTH", "02", "S02AMTH", "F02AMTH"];
        break;
      case 'G3':
      case 'GB':
      case '03AQUA':
      case 'SKYBLTOPAZ':
        stone_code_array = ["SkyBlTopaz", "SWKFancyBlue", "03", "S03AQUA", "G3", "GB", "03AQUA", "F03AQUA"];
        break;
      case '03':
      case 'S03AQUA':
      case 'MARCH':
      case 'AQUAMARINE':
      case 'F03AQUA':
        stone_code_array = ["SWKFancyBlue", "G3", "GB", "03AQUA", "03", "S03AQUA", "F03AQUA"];
        break;
      case 'G4':
      case '04DIAM':
      case 'GENUINE-DIAMOND':
      case 'WDIAM-I1':
      case 'WDIAM-I2':
      case 'WDIAM-I2-I3':
        stone_code_array = ["04LABDIAM", "F04DIAM", "SWKWhite", "04CZIR", "04", "G4", "04DIAM", "WDIAM-I1", "WDIAM-I2", "WDIAM-I2-I3"];
        break;
      case '04DIAM-I1':
        stone_code_array = ["SWKWhite", "04CZIR", "04", "G4", "04DIAM", "04DIAM-I1", "F04DIAM"];
        break;
      case '04DIAM-SI1':
        stone_code_array = ["SWKWhite", "04CZIR", "04", "G4", "04DIAM", "04DIAM-SI1", "F04DIAM"];
        break;
      case '04DIAM-SI2':
        stone_code_array = ["SWKWhite", "04CZIR", "04", "G4", "04DIAM", "04DIAM-SI2", "F04DIAM"];
        break;
      case '04CHDIA':
        stone_code_array = ["SWKWhite", "04CZIR", "04", "G4", "04DIAM", "WDIAM-I1", "WDIAM-I2", "WDIAM-I2-I3", "F04DIAM", "04CHDIA"];
        break;
      case '04LABDIAM':
        stone_code_array = ["SWKWhite", "04CZIR", "04", "G4", "04DIAM", "WDIAM-I1", "WDIAM-I2", "WDIAM-I2-I3", "F04DIAM", "04LABDIAM"];
        break;
      case '04GDIAM':
        stone_code_array = ["04LABDIAM", "SWKWhite", "04CZIR", "04", "G4", "04DIAM", "WDIAM-I1", "WDIAM-I2", "WDIAM-I2-I3", "F04DIAM", "04GDIAM"];
        break;
      case '04':
      case '04CZIR':
      case 'APRIL':
      case 'CUBIC-ZIRCONIA':
      case 'CUBIC ZIRCONIA':
      case 'F04DIAM':
        stone_code_array = ["SWKWhite", "04", "04CZIR", "F04DIAM"];
        break;
      case 'GW':
      case '04WTPZ':
      case 'WHITE-TOPAZ':
      case 'WHITE TOPAZ':
        stone_code_array = ["SWKWhite", "G4", "04DIAM", "WDIAM-I1", "WDIAM-I2", "WDIAM-I2-I3", "04", "04CZIR", "GW", "04WTPZ", "F04DIAM"];
        break;
      case '04BDIA':
      case 'GENUINE-BLACK-DIAMOND':
      case 'GENUINE BLACK DIAMOND':
      case 'F04BDIA':
        stone_code_array = ["SWKBlack", "04CZIR", "04", "G4", "04DIAM", "04BDIA", "F04BDIA"];
        break;
      case 'G5':
      case '05EMER':
        stone_code_array = ["GSAP", "SWKGreen", "05", "S05EMER", "C05EMER", "G5", "05EMER", "F05EMER"];
        break;
      case '05':
      case 'S05EMER':
      case 'C05EMER':
      case 'MAY':
      case 'EMERALD':
      case 'F05EMER':
        stone_code_array = ["GSAP", "SWKGreen", "G5", "05EMER", "05", "S05EMER", "C05EMER", "F05EMER"];
        break;
      case 'GSAP':
      case 'GREEN-SAPPHIRE':
      case 'GREEN SAPPHIRE':
      case 'GREENAMETH':
        stone_code_array = ["SWKGreen", "05", "S05EMER", "C05EMER", "G5", "05EMER", "GSAP", "GreenAmeth", "F05EMER"];
        break;
      case 'G6':
        stone_code_array = ["GQ", "06SQTZ", "GQ2", "66", "S06SQTZ", "G6"];
        break;
      case 'GQ':
      case '06SQTZ':
      case 'JUNE':
      case 'SMOKEY-QUARTZ':
      case 'SMOKEY QUARTZ':
        stone_code_array = ["SWKBlack", "GQ2", "66", "S06SQTZ", "GQ", "06SQTZ", "F06ALEX"];
        break;
      case 'GQ2':
      case '66':
      case 'S06SQTZ':
        stone_code_array = ["G6", "SWKBlack", "GQ", "06SQTZ", "GQ2", "66", "S06SQTZ", "F06ALEX"];
        break;
      case '06':
      case 'S06ALEX':
      case 'ALEXANDRITE':
      case 'F06ALEX':
        stone_code_array = ["SWKBlack", "GQ", "06SQTZ", "GQ2", "66", "S06SQTZ", "06", "S06ALEX", "F06ALEX"];
        break;
      case 'G7':
      case '07RUBY':
        stone_code_array = ["SWKRed", "07", "S07RUBY", "C07RUBY", "G7", "07RUBY", "F07RUBY"];
        break;
      case '07':
      case 'S07RUBY':
      case 'C07RUBY':
      case 'JULY':
      case 'RUBY':
      case 'F07RUBY':
        stone_code_array = ["SWKRed", "G7", "07RUBY", "07", "S07RUBY", "C07RUBY", "F07RUBY"];
        break;
      case 'G8':
      case 'GG':
      case '08PERI':
        stone_code_array = ["SWKFancyYellow", "08", "S08PERI", "G8", "GG", "08PERI", "F08PERI"];
        break;
      case '08':
      case 'S08PERI':
      case 'AUGUST':
      case 'PERIDOT':
      case 'F08PERI':
        stone_code_array = ["SWKFancyYellow", "G8", "GG", "08PERI", "08", "S08PERI", "F08PERI"];
        break;
      case 'G9':
      case 'GS':
      case '09BSAP':
      case 'IOLITE':
        stone_code_array = ["TANZ", "IOLITE", "SWKFancyBlue", "09", "S09BSAP", "C09BSAP", "G9", "GS", "09BSAP", "F09BSAP"];
        break;
      case '09':
      case 'S09BSAP':
      case 'C09BSAP':
      case 'SEPTEMBER':
      case 'BLUE-SAPPHIRE':
      case 'BLUE SAPPHIRE':
      case 'F09BSAP':
        stone_code_array = ["TANZ", "SWKFancyBlue", "G9", "GS", "09BSAP", "09", "S09BSAP", "C09BSAP", "F09BSAP"];
        break;
      case 'TANZ':
      case 'TANZANITE':
        stone_code_array = ["SWKFancyBlue", "09", "S09BSAP", "C09BSAP", "G9", "GS", "09BSAP", "TANZ", "F09BSAP"];
        break;
      case 'GT':
      case '10PTOU':
        stone_code_array = ["PSAP", "SPSAP", "CPSAP", "SWKFancyPink", "MORG", "10", "S10PTOU", "GT", "10PTOU", "F10PTOU"];
        break;
      case '10':
      case 'S10PTOU':
      case 'OCTOBER':
      case 'PINK-TOURMALINE':
      case 'PINK TOURMALINE':
      case 'F10PTOU':
        stone_code_array = ["PSAP", "SPSAP", "CPSAP", "SWKFancyPink", "MORG", "GT", "10PTOU", "10", "S10PTOU", "F10PTOU"];
        break;
      case 'PSAP':
      case 'PINK-SAPPHIRE':
      case 'PINK SAPPHIRE':
      case 'SPSAP':
      case 'CPSAP':
        stone_code_array = ["SWKFancyPink", "10", "S10PTOU", "MORG", "GT", "10PTOU", "PSAP", "SPSAP", "CPSAP", "F10PTOU"];
        break;
      case 'GO':
      case '10OPAL':
      case 'OPAL':
        stone_code_array = ["SWKWhite", "10", "S10PTOU", "MORG", "GT", "10PTOU", "GO", "S10OPAL", "10OPAL", "F10PTOU"];
        break;
      case 'S10OPAL':
        stone_code_array = ["SWKWhite", "10", "S10PTOU", "MORG", "GT", "10PTOU", "GO", "10OPAL", "F10PTOU", "S10OPAL"];
        break;
      case 'MORG':
        stone_code_array = ["PSAP", "SPSAP", "CPSAP", "SWKFancyPink", "10", "S10PTOU", "GT", "10PTOU", "F10PTOU", "MORG"];
        break;
      case 'GN':
      case '11CITR':
        stone_code_array = ["YSAP", "OSAP", "SWKGoldenYellow", "11", "S11CITR", "GN", "11CITR", "F11CITR"];
        break;
      case '11':
      case 'S11CITR':
      case 'NOVEMBER':
      case 'CITRINE':
      case 'F11CITR':
        stone_code_array = ["YSAP", "OSAP", "SWKGoldenYellow", "GN", "11CITR", "11", "S11CITR", "F11CITR"];
        break;
      case 'YSAP':
      case 'YELLOW-SAPPHIRE':
      case 'YELLOW SAPPHIRE':
        stone_code_array = ["SWKGoldenYellow", "11", "S11CITR", "GN", "11CITR", "YSAP", "F11CITR"];
        break;
      case 'OSAP':
      case 'ORANGE-SAPPHIRE':
      case 'ORANGE SAPPHIRE':
        stone_code_array = ["SWKGoldenYellow", "11", "S11CITR", "GN", "11CITR", "OSAP", "F11CITR"];
        break;
      case 'GZ':
      case '12BTPZ':
        stone_code_array = ["SWKFancyBlue", "12", "S12BTPZ", "GZ", "12BTPZ", "F12BTPZ"];
        break;
      case '12':
      case 'S12BTPZ':
      case 'DECEMBER':
      case 'BLUE-TOPAZ':
      case 'BLUE TOPAZ':
      case 'F12BTPZ':
        stone_code_array = ["SWKFancyBlue", "GZ", "12BTPZ", "12", "S12BTPZ", "F12BTPZ"];
        break;
      case 'SWKGOLDENYELLOW':
        stone_code_array = ["YSAP", "GN", "11CITR", "11", "S11CITR", "SWKGoldenYellow", "F11CITR"];
        break;
      case 'SWKLAVENDER':
        stone_code_array = ["G2", "02AMTH", "02", "S02AMTH", "SWKLavender", "F02AMTH"];
        break;
      case 'SWKAMETHYST':
        stone_code_array = ["G2", "02AMTH", "02", "S02AMTH", "SWKAmethyst", "F02AMTH"];
        break;
      case 'SWKRED':
        stone_code_array = ["G7", "07RUBY", "07", "S07RUBY", "SWKRed", "F07RUBY"];
        break;
      case 'SWKGREEN':
        stone_code_array = ["GSAP", "G5", "05EMER", "05", "S05EMER", "SWKGreen", "F05EMER"];
        break;
      case 'SWKMINT':
        stone_code_array = ["G5", "05EMER", "05", "S05EMER", "SWKMint", "F05EMER"];
        break;
      case 'SWKFANCYBROWN':
        stone_code_array = ["GQ", "06SQTZ", "GQ2", "66", "S06SQTZ", "SWKFancyBrown", "F06ALEX"];
        break;
      case 'SWKFANCYYELLOW':
        stone_code_array = ["OSAP", "G8", "GG", "08PERI", "08", "S08PERI", "SWKFancyYellow", "F08PERI"];
        break;
      case 'SWKFANCYPINK':
        stone_code_array = ["PSAP", "MORG", "GT", "10PTOU", "10", "S10PTOU", "SWKFancyPink", "F10PTOU"];
        break;
      case 'SWKFANCYBLUE':
      case 'BDIAM':
        stone_code_array = ["TANZ", "G9", "GS", "09BSAP", "09", "S09BSAP", "SWKFancyBlue", "BDIAM", "F09BSAP"];
        break;
      case 'SWKWHITE':
      case 'WSAP':
      case 'SWSAP':
      case 'CWSAP':
        stone_code_array = ["04", "04CZIR", "SWKWhite", "WSAP", "SWSAP", "CWSAP", "F04DIAM"];
        break;
      case 'SWKBLACK':
        stone_code_array = ["GQ", "06SQTZ", "GQ2", "66", "S06SQTZ", "04BDIA", "SWKBlack", "F04BDIA"];
        break;
      case 'GREENAMETH':
        stone_code_array = ["GSAP", "G5", "05EMER", "05", "S05EMER", "SWKGreen", "F05EMER"];
        break;
      case 'ROSEQTZ':
        stone_code_array = ["PSAP", "MORG", "GT", "10PTOU", "10", "S10PTOU", "SWKFancyPink", "F10PTOU", "RoseQtz"];
        break;
      case 'RNBWMOON':
        stone_code_array = ["RnbwMoon"];
        break;
      case 'LABRADORITE':
        stone_code_array = ["Labradorite"];
        break;
      case 'ORANGEMOON':
        stone_code_array = ["OrangeMoon"];
        break;
      case 'SUNSTONE':
        stone_code_array = ["Sunstone"];
        break;
      case 'BLACKONYX':
        stone_code_array = ["BlackOnyx"];
        break;
      default:
      stone_code_array = [stone_code];
    }
    return stone_code_array;
  } catch(e) {
    console.log('error:');
    console.log(e);
  }
}

export default similarStones
